real.ajax.json = function(url, options) {
    options = $.extend({
        contentType : 'application/json',
        dataType : 'text'
    }, options);

    const successFn = options.success;
    const errorFn = options.error;

    options.success = function(response) {
        response = real.ajax.handleResponse(url, response, jQueryAjaxSettings);
        if(typeof successFn === 'function') {
            successFn(response);
        }
    };

    options.error = function(response) {
        if(typeof errorFn === 'function') {
            errorFn(response);
        }
    };

    const jQueryAjaxSettings = real.ajax(url, options);
    return jQueryAjaxSettings;
};
